import type { ProductCategoryObject } from '@/types/products';

export const formatDate = (dateString: string | Date): string => {
  if (!dateString) return '-';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

export const formatCategoryName = (category: ProductCategoryObject): string => {
  if (!category) return '-';

  if (typeof category === 'string') return category;

  if (typeof category.name === 'string') return category.name;

  return category.name?.en || category.name?.uz || category.name?.ru || '-';
};
